export default function locale(target: any, prop: string) {

  const validLocales = ['en' , 'af' , 'ar-dz' , 'ar-kw' , 'ar-ly' , 'ar-ma' , 'ar-sa' , 'ar-tn' , 'ar' , 'az' , 'be' ,
    'bg' , 'bm' , 'bn' , 'bo' , 'br' , 'bs' , 'ca' , 'cs' , 'cv' , 'cy' , 'da' , 'de-at' , 'de-ch' , 'de' , 'dv' , 'el' ,
    'en-au' , 'en-ca' , 'en-gb' , 'en-ie' , 'en-nz', 'eo' , 'es-do' , 'es-us' , 'es' , 'et' , 'eu' , 'fa' , 'fi' ,
    'fo' , 'fr-ca' , 'fr-ch' , 'fr' , 'fy' , 'gd' , 'gl' , 'gom-latn' , 'gu' , 'he', 'hi' , 'hr' , 'hu' , 'hy-am' ,
    'id' , 'is' , 'it' , 'ja' , 'jv' , 'ka' , 'kk' , 'km' , 'kn' , 'ko' , 'ky' , 'lb' , 'lo' , 'lt' , 'lv' , 'me' ,
    'mi', 'mk' , 'ml' , 'mr' , 'ms-my' , 'ms' , 'mt' , 'my' , 'nb' , 'ne' , 'nl-be' , 'nl' , 'nn' , 'pa-in' , 'pl' ,
    'pt-br' , 'pt' , 'ro' , 'ru' , 'sd', 'se' , 'si' , 'sk' , 'sl' , 'sq' , 'sr-cyrl' , 'sr' , 'ss' , 'sv' , 'sw' ,
    'ta' , 'te' , 'tet' , 'th' , 'tl-ph' , 'tlh' , 'tr' , 'tzl', 'tzm-latn' , 'tzm' , 'uk' , 'ur' , 'uz-latn' , 'uz' ,
    'vi' , 'x-pseudo' , 'yo' , 'zh-cn' , 'zh-hk' , 'zh-tw'];
  const NG_ON_ONIT_NAME = 'ngOnInit';

  /** ngOnInit might not be implemented by this component */
  const ngOnInitClone: Function|null = target[NG_ON_ONIT_NAME];

  Object.defineProperty(target, NG_ON_ONIT_NAME, {
    value: function() {
      if (this[prop]) {
        this[prop] = this[prop];
        if (validLocales.indexOf(this[prop]) === -1) {
          console.error(
            target.constructor.name +
`: ${this[prop]} is not valid locale value\nvalid values:
en = English
af = Afrikaans
ar-dz = Arabic (Algeria)
ar-kw = Arabic (Kuwait)
ar-ly = Arabic (Libya)
ar-ma = Arabic (Morocco)
ar-sa = Arabic (Saudi Arabia)
ar-tn = Arabic (Tunisia)
ar = Arabic
az = Azerbaijani
be = Belarusian
bg = Bulgarian
bm = Bambara
bn = Bengali
bo = Tibetan
br = Breton
bs = Bosnian
ca = Catalan
cs = Czech
cv = Chuvash
cy = Welsh
da = Danish
de-at = German (Austria)
de-ch = German (Switzerland)
de = German
dv = Divehi
el = Greek
en-au = English (Australia)
en-ca = English (Canada)
en-gb = English (United Kingdom)
en-ie = English (Ireland)
en-nz = English (New Zealand)
eo = Esperanto
es-do = Spanish (Dominican Republic)
es-us = Spanish (United States)
es = Spanish
et = Estonian
eu = Basque
fa = Persian
fi = Finnish
fo = Faroese
fr-ca = French (Canada)
fr-ch = French (Switzerland)
fr = French
fy = Western Frisian
gd = Scottish Gaelic
gl = Galician
gom-latn = gom (Latin)
gu = Gujarati
he = Hebrew
hi = Hindi
hr = Croatian
hu = Hungarian
hy-am = Armenian (Armenia)
id = Indonesian
is = Icelandic
it = Italian
ja = Japanese
jv = Javanese
ka = Georgian
kk = Kazakh
km = Khmer
kn = Kannada
ko = Korean
ky = Kirghiz
lb = Luxembourgish
lo = Lao
lt = Lithuanian
lv = Latvian
me = me
mi = Maori
mk = Macedonian
ml = Malayalam
mr = Marathi
ms-my = Malay (Malaysia)
ms = Malay
mt = Maltese
my = Burmese
nb = Norwegian BokmÃ¥l
ne = Nepali
nl-be = Dutch (Belgium)
nl = Dutch
nn = Norwegian Nynorsk
pa-in = Punjabi (India)
pl = Polish
pt-br = Portuguese (Brazil)
pt = Portuguese
ro = Romanian
ru = Russian
sd = Sindhi
se = Northern Sami
si = Sinhala
sk = Slovak
sl = Slovenian
sq = Albanian
sr-cyrl = Serbian (Cyrillic)
sr = Serbian
ss = Swati
sv = Swedish
sw = Swahili
ta = Tamil
te = Telugu
tet = Tetum
th = Thai
tl-ph = Tagalog (Philippines)
tlh = Klingon
tr = Turkish
tzl = tzl
tzm-latn = tzm (Latin)
tzm = tzm
uk = Ukrainian
ur = Urdu
uz-latn = Uzbek (Latin)
uz = Uzbek
vi = Vietnamese
x-pseudo = x-pseudo
yo = Yoruba
zh-cn = Chinese (China)
zh-hk = Chinese (Hong Kong SAR China)
zh-tw = Chinese (Taiwan)`
          );
          this[prop] = 'en-us';
        }
      } else {
        this[prop] = 'en-us';
      }
      // Calling the original ngOnInit with its original context
      if ( ngOnInitClone ) {
        ngOnInitClone.call(this);
      }
    }
  });
}
